import { createRequestReducer } from "redux-request-state";

import * as smsActions from "./sms.actions";

export const smsStatistics = createRequestReducer({
    begin: smsActions.REQUEST_SMS_STATISTICS,
    success: smsActions.RECEIVE_SMS_STATISTICS,
    failure: smsActions.ERROR_SMS_STATISTICS
});